<template>
  <div class="moneny-card">
    <bill-card class="mb-2" :height="height">
      <div class="title d-flex align-items-center">
        <div class="flex-fill line-height-0">
          <template>
            <slot name="title" />
            <span v-if="!$slots.title">{{ title }}</span>
          </template>
          <icon v-if="icon" :type="icon" class="ml-2" style="font-size: 12px" />
        </div>
        <template v-if="showAlert">
          <a-icon type="bell" theme="twoTone" /><a-button type="link" size="small" class="p-0" @click="() => $emit('btnClick')"> {{ btnTitle }}</a-button>
        </template>
      </div>
      <div :class="['clearfix', 'template-layout']" style="height: 74px;" v-if="isDefaultFormat">
        <a-tooltip v-if="tooltip">
          <template slot="title">{{tooltip}}</template>
          <span :class="numberStyle" v-if="!moneyIsNil">{{money==='-'?'':currencySign}} {{moneyFilter(money)}}</span>
          <span :class="numberStyle" v-if="!valueIsNil">{{value==='-'?'':currencySign}} {{value}}</span>
        </a-tooltip>
        <template v-else>
          <span :class="numberStyle" v-if="!moneyIsNil">{{money==='-'?'':currencySign}} {{moneyFilter(money)}}</span>
          <span :class="numberStyle" v-if="!valueIsNil">{{value==='-'?'':currencySign}} {{value}}</span>
        </template>
        <!-- <span class="yuan" v-if="showUnit">{{ currencyCn }}</span> -->
        <div :class="['yuan', 'yuan-second-line']" v-if="showIncrease && increase">
          <div class="increase-link mr-1" @click="handleIncreaseClick">{{$t('bill.text_307')}}</div>
          <div :style="{color: increase>0?'rgb(245, 34, 45)':'rgb(82, 196, 26)'}">
            <icon type="up" :style="{marginRight:'2px',transform:`rotate(${increase>=0?0:180}deg)`, color: increase>0?'rgb(245, 34, 45)':'rgb(82, 196, 26)'}" />
            {{increaseText}}
          </div>
        </div>
      </div>
      <template #customizeContent>
        <slot name="customizeContent" />
      </template>
    </bill-card>
  </div>
</template>

<script>
import * as R from 'ramda'
import BillCard from '@Bill/components/BillCard'
import { numerify } from '@/filters'
import i18n from '@/locales'
import { currencyUnitMap } from '@/constants/currency'

export default {
  name: 'MoneyCard',
  components: {
    BillCard,
  },
  props: {
    title: String,
    icon: String,
    tooltip: String,
    money: [String, Number],
    value: [String, Number],
    height: String,
    btnTitle: {
      type: String,
      default: i18n.t('bill.text_54'),
    },
    showAlert: {
      type: Boolean,
      default: false,
    },
    currencyCn: {
      type: String,
      default: i18n.t('bill.text_29'),
    },
    currencySign: {
      type: String,
      defualt: currencyUnitMap.CNY.sign,
    },
    showUnit: {
      type: Boolean,
      default: false,
    },
    increase: {
      type: Number,
      default: 0,
    },
    showIncrease: {
      Boolean,
      default: false,
    },
    isDefaultFormat: {
      type: Boolean,
      default: true,
    },
    numberFontColor: {
      type: String,
    },
  },
  computed: {
    moneyIsNil () {
      return R.isNil(this.money)
    },
    valueIsNil () {
      return R.isNil(this.value)
    },
    numberStyle () {
      const isUsedDefault = Boolean(this.numberFontColor)
      const obj = {
        num: true,
        'number-default-color': !isUsedDefault,
      }
      if (isUsedDefault) {
        obj[this.numberFontColor] = true
      }
      return obj
    },
    increaseText () {
      const d = this.increase
      if (d === 0) {
        return '0%'
      } else if (d > 0) {
        if (Math.abs(d) < 0.00001) {
          return '<0.01%'
        }
        if (Math.abs(d) > 10000) {
          return '∞'
        }
        return `${numerify(Math.abs(d), '0.00%')}`
      } else {
        if (Math.abs(d) < 0.00001) {
          return '<0.01%'
        }
        return `${numerify(Math.abs(d), '0.00%')}`
      }
    },
  },
  methods: {
    handleIncreaseClick () {
      this.$emit('increaseClick')
    },
    moneyFilter (money) {
      const val = parseFloat(money)
      // if (val > 10000000) {
      //   return numerify(val, '0,0')
      // }
      return numerify(val, '0,0.00')
    },
  },
}
</script>

<style lang="less" scoped>
.moneny-card {
  .title {
    font-size: 12px;
  }
  .num {
    float: left;
    height: 100%;
    font-size: 30px;
    font-weight: bold;
    line-height: 37px;
    padding-top: 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .number-default-color {
    color: #000000;
  }
  .predictionColor {
    color: rgb(129, 189, 221);
    // color: transparent;
    // text-shadow: #4DA1FF 0 0 2px;
  }
  .yuan {
    // float: right;
    color: #000;
    font-size: 14px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    div{
      text-align: right;
    }
  }
  .template-layout {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  .yuan-second-line {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    transform: translateY(-12px);
    div {
      text-align: right;
    }
  }
  .warning {
    font-size: 12px;
  }
  .increase-link:hover {
    cursor: pointer;
    color: var(--antd-wave-shadow-color);
  }
  .line-height-0 {
    line-height: 0;
  }
}
</style>
